import React, { useEffect } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import Paper from '@material-ui/core/Paper';
import MaterialTable, { MTableToolbar } from 'material-table';
import { connect } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tab from '@material-ui/core/Tab';
import { TabList, TabContext, TabPanel } from '@material-ui/lab';
import moment from 'moment';
import { IsEmpty } from '../../common/checks';
import apiService from '../../services.js/apiService';

const themeTable = createMuiTheme({
  overrides: {
    MuiTableRow: {
      root: {
        '&:hover': {
          transition:      '0.3s ease',
          backgroundColor: '#42d1f5',
        },
      },
    },
  },
});

const FlaggedReviews = () => {
  const [value, setValue] = React.useState('1');
  const [reviews, setReviews] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getFlaggedReviews = async () => {
    try {
      const result = await apiService.getFlaggedReviews();
      setReviews(result);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFlaggedReviews();
  }, []);

  return (
    <Paper elevation={0}>
      <Typography className="mt-2 mb-2 ml-2" variant="h5">List of incomplete review information.</Typography>
      <Typography className="mb-2 ml-2" variant="subtitle1">*The following review information below needs to be handled:</Typography>

      <TabContext value={value}>
        <TabList onChange={handleChange} aria-label="tabs table">
          <Tab value="1" label={`Addresses (${reviews.noCuisineTagsOrNotLiveReviews ? reviews.noCuisineTagsOrNotLiveReviews.length : 0})`} style={{ color: '#f50057' }} />
          <Tab value="2" label={`Pages (${reviews.reviewWithPlaceLocationNoOutlet ? reviews.reviewWithPlaceLocationNoOutlet.length : 0})`} style={{ color: '#f50057' }} />
        </TabList>

        <TabPanel value="1">
          <ThemeProvider theme={themeTable}>
            {loading
              ? (
                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
              )
              : (
                <MaterialTable
                  components={{
                    Toolbar: (p) => (
                      <div>
                        <MTableToolbar {...p} />
                        <div className="ml-5">
                          <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following review(s) is either:</Typography>
                          <Typography variant="body1" color="textSecondary">1) status is not Live</Typography>
                          <Typography variant="body1" color="textSecondary">2) has no cuisine tag</Typography>
                        </div>
                      </div>
                    ),
                  }}
                  columns={[
                    { title: 'Id', field: 'id', width: '10%', render: (review) => <a href={`page/${review.pageId}/review/${review.id}`} target="_blank" rel="noreferrer">{review.id}</a> },
                    { title: 'Reviewer Page Id', field: 'pageId', width: '12%' },
                    { title: 'Title', field: 'title', filtering: false, render: (review) => (!IsEmpty(review.title) ? review.title.replace(/(.{100})..+/, '$1…') : '') },
                    { title: 'Status', field: 'status', width: '5%' },
                    { title: 'Cuisine Tags', field: 'cuisineTags', render: (review) => !IsEmpty(review.cuisineTags) && review.cuisineTags.join(', ') },
                  ]}
                  data={reviews.noCuisineTagsOrNotLiveReviews ? reviews.noCuisineTagsOrNotLiveReviews : []}
                  title=""
                  options={{
                    showTitle: false,
                  }}
                />
              )}
          </ThemeProvider>
        </TabPanel>
        <TabPanel value="2">
          <ThemeProvider theme={themeTable}>
            {loading
              ? (
                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
              )
              : (
                <MaterialTable
                  components={{
                    Toolbar: (p) => (
                      <div>
                        <MTableToolbar {...p} />
                        <div className="ml-5">
                          <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following review(s) is:</Typography>
                          <Typography variant="body1" color="textSecondary">1) status is Live but linked Place Page doesn&apos;t have an outlet </Typography>
                        </div>
                      </div>
                    ),
                  }}
                  columns={[
                    { title: 'Id', field: 'reviewId', width: '8%', render: (review) => <a href={`page/${review.pageId}/review/${review.reviewId}`} target="_blank" rel="noreferrer">{review.reviewId}</a> },
                    { title: 'Reviewer Page Id', field: 'pageId', width: '8%' },
                    { title: 'Linked Page Id', field: 'placePageId', width: '12%', render: (review) => <a href={`page/${review.placePageId}/outlets`} target="_blank" rel="noreferrer">{review.placePageId}</a> },
                    { title: 'Linked Page Name', field: 'placePageName', width: '15%', render: (review) => <a href={`page/${review.placePageId}/outlets`} target="_blank" rel="noreferrer">{review.placePageName}</a> },
                    { title: 'Title', field: 'title', filtering: false, render: (review) => (!IsEmpty(review.title) ? review.title.replace(/(.{80})..+/, '$1…') : '') },
                    { title: 'Status', field: 'status', width: '5%' },
                    { title: 'Updated At', field: 'updatedAt', width: '10%', render: (review) => (review.updatedAt !== null ? `${moment(review.updatedAt).format('D MMM YYYY HH:mm')}` : '-') },
                    { title: 'Last Updated By', field: 'lastUpdatedBy', width: '10%' },
                  ]}
                  data={reviews.reviewWithPlaceLocationNoOutlet ? reviews.reviewWithPlaceLocationNoOutlet : []}
                  title=""
                  options={{
                    showTitle: false,
                  }}
                />
              )}
          </ThemeProvider>
        </TabPanel>
      </TabContext>
    </Paper>
  );
};

export default connect(null, null)(FlaggedReviews);
